"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require("@babel/polyfill");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Map = require("../../components/Map/Map");

var _Map2 = _interopRequireDefault(_Map);

var _MapStyles = require("../../components/MapStyles/MapStyles");

var _MapStyles2 = _interopRequireDefault(_MapStyles);

var _PanelMapVisualizations = require("../../components/PanelMapVisualizations/PanelMapVisualizations");

var _PanelMapVisualizations2 = _interopRequireDefault(_PanelMapVisualizations);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _utils = require("../../common/utils");

var _utils2 = _interopRequireDefault(_utils);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _PanelVisualitzarDades = require("./PanelVisualitzarDades.css");

var _PanelVisualitzarDades2 = _interopRequireDefault(_PanelVisualitzarDades);

var _PanelMapInformation = require("../PanelMapInformation/PanelMapInformation");

var _PanelMapInformation2 = _interopRequireDefault(_PanelMapInformation);

var _PanelPropietatsVisor = require("../PanelPropietatsVisor/PanelPropietatsVisor");

var _PanelPropietatsVisor2 = _interopRequireDefault(_PanelPropietatsVisor);

var _PanelGetFeatureInfo = require("../PanelGetFeatureInfo/PanelGetFeatureInfo");

var _PanelGetFeatureInfo2 = _interopRequireDefault(_PanelGetFeatureInfo);

var _PanelPropertiesInfoSelector = require("../PanelPropertiesInfoSelector/PanelPropertiesInfoSelector");

var _PanelPropertiesInfoSelector2 = _interopRequireDefault(_PanelPropertiesInfoSelector);

var _PanelMessageGenerateAPP = require("../PanelMessageGenerateAPP/PanelMessageGenerateAPP");

var _PanelMessageGenerateAPP2 = _interopRequireDefault(_PanelMessageGenerateAPP);

var _PanelMessageError = require("../PanelMessageError/PanelMessageError");

var _PanelMessageError2 = _interopRequireDefault(_PanelMessageError);

var _PanelButtonsVisualizations = require("../PanelButtonsVisualizations/PanelButtonsVisualizations");

var _PanelButtonsVisualizations2 = _interopRequireDefault(_PanelButtonsVisualizations);

var _PanelSocialButtons = require("../PanelSocialButtons/PanelSocialButtons");

var _PanelSocialButtons2 = _interopRequireDefault(_PanelSocialButtons);

var _PanelFilterButtons = require("../PanelFilterButtons/PanelFilterButtons");

var _PanelFilterButtons2 = _interopRequireDefault(_PanelFilterButtons);

var _PanelCercadorMap = require("../PanelCercadorMap/PanelCercadorMap");

var _PanelCercadorMap2 = _interopRequireDefault(_PanelCercadorMap);

var _PanelLegendVisualizations = require("../PanelLegendVisualizations/PanelLegendVisualizations");

var _PanelLegendVisualizations2 = _interopRequireDefault(_PanelLegendVisualizations);

var _PanelModificaRangTemporal = require("../PanelModificaRangTemporal/PanelModificaRangTemporal");

var _PanelModificaRangTemporal2 = _interopRequireDefault(_PanelModificaRangTemporal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //     


//import { false } from "tap";
//import { false } from "tap";

var PanelVisualitzarDades = function (_Component) {
  _inherits(PanelVisualitzarDades, _Component);

  function PanelVisualitzarDades(props) {
    _classCallCheck(this, PanelVisualitzarDades);

    var _this = _possibleConstructorReturn(this, (PanelVisualitzarDades.__proto__ || Object.getPrototypeOf(PanelVisualitzarDades)).call(this, props));

    _initialiseProps.call(_this);

    var index = props.dataJsonConfig.vieweroptions.thematicoptions.findIndex(_this.findFirstVisible);

    _this.state = {
      showGetFeatureInfo: false,
      showPanelGeneratedApp: false,
      showPanelGeneratedAppError: false,
      showPanelModificaRangTemporal: false,
      errorMessage: "",
      generatingApp: false,
      activeIndex: 0,
      currentFeature: {},
      stationsFonts: [],
      loadingMap: true,
      saveAsNewMap: false,
      TAGoptions: {
        tags: ["Temporal", "Diari", "Setmanal", "Històric", "Hivern", "Estiu", "Primavera", "Tardor", "Pluja", "Inundacions", "Gelades"]
      },
      currentVis: index !== -1 ? index : 0,
      TAGSoptions: {
        tags: [{ key: "Temporal", text: "Temporal", value: "Temporal" }, { key: "Diari", text: "Diari", value: "Diari" }, { key: "Setmanal", text: "Setmanal", value: "Setmanal" }, { key: "Històric", text: "Històric", value: "Històric" }, { key: "Hivern", text: "Hivern", value: "Hivern" }, { key: "Estiu", text: "Estiu", value: "Estiu" }, { key: "Primavera", text: "Primavera", value: "Primavera" }, { key: "Tardor", text: "Tardor", value: "Tardor" }, { key: "Pluja", text: "Pluja", value: "Pluja" }, { key: "Inundacions", text: "Inundacions", value: "Inundacions" }, { key: "Gelades", text: "Gelades", value: "Gelades" }]
      },
      width: window.innerWidth
    };

    _this.map = _react2.default.createRef();
    _this.BBOXoptions = [{
      key: 0,
      text: "catalunya",
      value: {
        zoom: 7.528205239948098,
        pitch: 0.5,
        bearing: 0.053416114371771066,
        lat: 41.70633307436347,
        lon: 1.2896014239208853
      }
    }];
    //this.TAGSoptions ={"tags":[{"key":"Temporal","text":"Temporal","value":"Temporal"},{"key":"Diari","text":"Diari","value":"Diari"},{"key":"Setmanal","text":"Setmanal","value":"Setmanal"},{"key":"Històric","text":"Històric","value":"Històric"},{"key":"Hivern","text":"Hivern","value":"Hivern"},{"key":"Estiu","text":"Estiu","value":"Estiu"},{"key":"Primavera","text":"Primavera","value":"Primavera"},{"key":"Tardor","text":"Tardor","value":"Tardor"},{"key":"Pluja","text":"Pluja","value":"Pluja"},{"key":"Inundacions","text":"Inundacions","value":"Inundacions"},{"key":"Gelades","text":"Gelades","value":"Gelades"}]};
    window.addEventListener("resize", _this.handleWindowSizeChange);
    _this._isMounted = false;
    return _this;
  }

  _createClass(PanelVisualitzarDades, [{
    key: "findFirstVisible",
    value: function findFirstVisible(element) {
      return element.isVisible;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this._isMounted && this.getTAGSOptions();
      this._isMounted && this.manageMapData(this.props.dataJsonConfig.vieweroptions.geojsonpath);
      this._isMounted && this.getBBOXOptions();
    }
  }, {
    key: "getBBOXOptions",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resBboxOtions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _utils2.default.getFileObjectContent(CONSTANTS.URL_SERVER, "bbox.txt");

              case 2:
                resBboxOtions = _context.sent;

                this.BBOXoptions = resBboxOtions ? resBboxOtions : this.BBOXoptions;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBBOXOptions() {
        return _ref.apply(this, arguments);
      }

      return getBBOXOptions;
    }()
  }, {
    key: "getTAGSOptions",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var orga, FILE_TAGS, resTagsOtions, newTAGSoptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                orga = this.props.dataJsonConfig.organization;
                FILE_TAGS = CONSTANTS.TAGS_FILENAME_TV3;


                if (orga === CONSTANTS.ORGA_SMC) {
                  FILE_TAGS = CONSTANTS.TAGS_FILENAME_SMC;
                }
                if (orga === CONSTANTS.ORGA_ICGC) {
                  FILE_TAGS = CONSTANTS.TAGS_FILENAME_ICGC;
                }

                _context2.next = 6;
                return _utils2.default.getFileObjectContent(CONSTANTS.URL_SERVER, FILE_TAGS);

              case 6:
                resTagsOtions = _context2.sent;
                newTAGSoptions = resTagsOtions ? resTagsOtions : this.state.TAGSoptions;

                this.TAGSoptions = newTAGSoptions;
                this._isMounted && this.setState({ TAGSoptions: newTAGSoptions });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTAGSOptions() {
        return _ref2.apply(this, arguments);
      }

      return getTAGSOptions;
    }()
  }, {
    key: "addTAGSoptions",
    value: function addTAGSoptions(value) {
      var arrayTags = this.state.TAGSoptions;

      arrayTags.tags.push({ key: value, text: value, value: value });

      this._isMounted && this.setState({ TAGoptions: arrayTags });
    }
  }, {
    key: "updateCalendarViewer",
    value: function updateCalendarViewer(prop, values) {
      //this.setState({ loadingMap: true });
      this.updateLayoutOptions("title", CONSTANTS.DEFAULT_TITOL_GENERIC);

      setTimeout(function () {
        this.props.updateJsonConfig(prop, values);
      }.bind(this), 100);

      //this
      var that = this;

      setTimeout(function () {
        //Start the timer

        that.doGenerateGeojson("", true).then(function () {
          that.map.current.updateVisualitzacio(that.props.dataJsonConfig.vieweroptions.thematicoptions[that.state.currentVis]);

          that.map.current.refreshMap();

          that.setState({
            showPanelModificaRangTemporal: false
          });
        }).catch(function (err) {
          console.info(err);
        });

        //After 1 second, set render to true
      }.bind(this), 500);
    }
  }, {
    key: "manageMapData",
    value: function manageMapData(urlGeojson) {
      var _this2 = this;

      this.doGenerateGeojson(urlGeojson, false).then(function () {
        if (_this2.props.dataJsonConfig.vieweroptions.thematicoptions.length === 0) {
          _this2.updateViewerOptions("thematicoptions", [].concat(_toConsumableArray(_this2.props.dataJsonConfig.vieweroptions.thematicoptions), [_this2.doGenerateDefaultVisualization()]));
        }
        _this2._isMounted && _this2.setState({ loadingMap: false });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowSizeChange);
      this._isMounted = false;
    }
  }, {
    key: "doGenerateDefaultVisualization",
    value: function doGenerateDefaultVisualization() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var defaultField = this.props.dataJsonConfig.calcdatafields[0];

      var colorScale = CONSTANTS.DEFAULT_SCALE;
      var timestamp = Date.now();

      var newVis = {
        title: "Visualitzacio " + index,
        id: timestamp,
        visualization: {
          title: "Camp " + defaultField,
          weathericon: "thermometer",
          weathercoloricon: "vermell"
        },
        layers: [{
          name: "" + timestamp + CONSTANTS.DEFAULT_INDEX_SUFFIX_POL,
          type: "Polygon3D",
          visibility: true,
          extrussion: 200,
          style: {}
        }, {
          name: "" + timestamp + CONSTANTS.DEFAULT_INDEX_SUFFIX_TEXT,
          type: "Text",
          visibility: true,
          fontsize: 3,
          fontname: "Noto Sans Bold",
          badge: false,
          style: {}
        }],

        field: defaultField,
        fieldvalue: "_value",

        colorrangs: {
          colorscale: colorScale,
          colorscaleType: "rangs",
          label: "PuBu"
        },
        labelrangs: [],
        labellegend: "Label " + defaultField,
        op: "",
        isVisible: true //(index === 0)
      };

      return newVis;
    }
  }, {
    key: "doGenerateGeojson",
    value: function doGenerateGeojson(urlGeojson, newVisor) {
      var _this3 = this;

      return new Promise(function (resolve) {
        if (urlGeojson === "") {
          _request2.default.post(CONSTANTS.URL_GENERATE_GEOJSON, _this3.props.dataJsonConfig).then(function (data) {
            var url = data.ok ? data.geojsonpath : CONSTANTS.DEFAULT_GEOJSONPATH_URL;
            _this3.updateViewerOptions("geojsonpath", url);
            _this3.updateApps("visor", data.visor);
            _this3.updateApps("editor", data.editor);

            resolve();
          }).catch(function (err) {
            console.log(err);
            _this3.updateViewerOptions("geojsonpath", CONSTANTS.DEFAULT_GEOJSONPATH_URL);
            resolve();
          });
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "updateViewerOptions",
    value: function updateViewerOptions(prop, value) {
      var newViewerOptions = _extends({}, this.props.dataJsonConfig.vieweroptions, _defineProperty({}, prop, value));

      this.props.updateJsonConfig("vieweroptions", newViewerOptions);

      this.setState({ showGetFeatureInfo: false });
    }
  }, {
    key: "visualizationChanged",
    value: function visualizationChanged(index, visualitzacio) {
      var doSetVisualization = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      // if (visualitzacio.field === 'alt'){
      // 	console.log('altttt')
      // 	visualitzacio.labelrangs= ['0', ' ', '2000', ' ', '4000']
      // }
      if (doSetVisualization) {
        this.map.current.updateVisualitzacio(visualitzacio);
        this.map.current.updateLayersVisibilityOfVisualitzacio(visualitzacio, visualitzacio.isVisible, index);
      }

      var newThematicOptions = [].concat(_toConsumableArray(this.props.dataJsonConfig.vieweroptions.thematicoptions));
      newThematicOptions[index] = visualitzacio;
      // console.log('new',newThematicOptions)
      this.updateViewerOptions("thematicoptions", newThematicOptions);
      // console.log('change', index, visualitzacio)
    }
  }, {
    key: "visualitzacioVisibleChanged",
    value: function visualitzacioVisibleChanged(newIndex) {
      var newThematicOptions = [].concat(_toConsumableArray(this.props.dataJsonConfig.vieweroptions.thematicoptions));

      newThematicOptions[this.state.currentVis].isVisible = false;
      newThematicOptions[newIndex].isVisible = true;

      /* this.map.removeVisualizationFromIndex(this.state.currentVis);
      this.map.setVisualization(newIndex, newThematicOptions[newIndex]); */

      this.map.current.updateLayersVisibilityOfVisualitzacio(newThematicOptions[this.state.currentVis], false, this.state.currentVis);
      this.map.current.updateLayersVisibilityOfVisualitzacio(newThematicOptions[newIndex], true, newIndex);

      this.setState({ currentVis: newIndex });
      this.updateViewerOptions("thematicoptions", newThematicOptions);
    }
  }, {
    key: "removeVisualization",
    value: function removeVisualization(index) {
      this.map.current.removeVisualizationFromIndex(this.props.dataJsonConfig.vieweroptions.thematicoptions[index].id);

      var newTemOpt = [].concat(_toConsumableArray(this.props.dataJsonConfig.vieweroptions.thematicoptions));
      newTemOpt.splice(index, 1);

      if (index === this.state.currentVis) {
        var newIndex = this.state.currentVis - 1 >= 0 ? this.state.currentVis - 1 : 0;
        newTemOpt[newIndex].isVisible = true;
        this.map.current.updateLayersVisibilityOfVisualitzacio(newTemOpt[newIndex], true, newIndex);
        this.setState({ currentVis: newIndex });
      } else if (this.state.currentVis > index) {
        this.setState({ currentVis: this.state.currentVis - 1 });
      }

      this.updateViewerOptions("thematicoptions", newTemOpt);
    }
  }, {
    key: "addVisualization",
    value: function addVisualization() {
      var index = this.props.dataJsonConfig.vieweroptions.thematicoptions.length;
      var newVis = this.doGenerateDefaultVisualization(index);

      var newThematicOptions = [].concat(_toConsumableArray(this.props.dataJsonConfig.vieweroptions.thematicoptions));

      newThematicOptions[this.state.currentVis].isVisible = false;
      newThematicOptions[index] = newVis;

      this.map.current.updateLayersVisibilityOfVisualitzacio(newThematicOptions[this.state.currentVis], false, this.state.currentVis);
      this.map.current.addNewVisualitzacioLayers(newVis, index);

      this.setState({ currentVis: index });
      this.updateViewerOptions("thematicoptions", newThematicOptions);
    }
  }, {
    key: "zoomToMap",
    value: function zoomToMap(value) {
      var pr = value.split(",");
      this.map.current.map.fitBounds([[parseFloat(pr[0]), parseFloat(pr[1])], [parseFloat(pr[2]), parseFloat(pr[3])]]);
    }
  }, {
    key: "getPanels",
    value: function getPanels() {
      var _this4 = this;

      var jsonConfig = this.props.dataJsonConfig;
      var fieldsCalcValues = _share2.default.generateListCalcValues(jsonConfig.calcdatafieldsCalculs);

      var panels = [{
        title: {
          content: "Fons del Mapa",
          key: "title-" + 0
        },
        content: {
          content: _react2.default.createElement(_MapStyles2.default, {
            vieweroptions: jsonConfig.vieweroptions,
            updateMap: this.updateViewerOptions.bind(this)
          }),
          key: "content-" + 0
        }
      }, {
        title: {
          content: "Visualitzacions",
          key: "title-" + 1
        },
        content: {
          content: _react2.default.createElement(_PanelMapVisualizations2.default, {
            ref: function ref(instance) {
              return _this4.visualizations = instance;
            },
            thematics: this.props.dataJsonConfig.vieweroptions.thematicoptions,
            fieldsToVisualize: this.props.dataJsonConfig.calcdatafields,
            organization: this.props.dataJsonConfig.organization,
            fieldsCalcValues: fieldsCalcValues,
            panelIndex: this.state.activeIndex,
            onChangeVisualitzacio: function onChangeVisualitzacio(index, data) {
              return _this4.visualizationChanged(index, data);
            },
            onChangeVisible: function onChangeVisible(newIndex) {
              return _this4.visualitzacioVisibleChanged(newIndex);
            },
            onRemoveVisualitzacio: function onRemoveVisualitzacio(index) {
              return _this4.removeVisualization(index);
            },
            onAddVisualitzacio: function onAddVisualitzacio() {
              return _this4.addVisualization();
            },
            currentVis: this.state.currentVis
          }),
          key: "content-" + 1
        }
      }, {
        title: {
          content: "Informació",
          key: "title-" + 2
        },
        content: {
          content: _react2.default.createElement(_PanelMapInformation2.default, {
            thematics: this.props.dataJsonConfig.vieweroptions.thematicoptions,
            tooltipfields: this.props.dataJsonConfig.tooltipfields,
            infowindow: this.props.dataJsonConfig.vieweroptions.infowindow,
            updateInfowindowProps: this.updateInfowindowProps.bind(this),
            calcdatafields: this.props.dataJsonConfig.calcdatafields,
            selectedfieldsLabels: this.props.dataJsonConfig.selectedfieldsLabels,
            updateSelectedfieldsLabels: this.updateSelectedfieldsLabels.bind(this)
          }),

          key: "content-" + 2
        }
      }, {
        title: {
          content: "Propietats visor",
          key: "title-" + 3
        },
        content: {
          content: _react2.default.createElement(_PanelPropietatsVisor2.default, {
            layoutOptions: this.props.dataJsonConfig.vieweroptions.layoutoptions,
            thematicoptions: this.props.dataJsonConfig.vieweroptions.thematicoptions,
            data: this.props.dataJsonConfig.data,
            updateLayoutOptions: this.updateLayoutOptions,
            BBOXoptions: this.BBOXoptions,
            TAGSoptions: this.state.TAGSoptions,
            addTAGSoptions: this.addTAGSoptions.bind(this),
            updateMapview: this.updateMapview,
            organization: this.props.dataJsonConfig.organization
          }),

          key: "content-" + 3
        }
      }];

      return panels;
    }
  }, {
    key: "updateLayerStyle",
    value: function updateLayerStyle(style, index) {
      var styleArray = [];
      var styleArraySimple = [];
      var init = style[0] === "interpolate" ? 3 : 2;

      for (var i = init; i < style.length; i++) {
        if (typeof style[i] === "number") {
          styleArray.push(style[i]);
        }
      }

      for (var j = 0; j < styleArray.length; j++) {
        if (j === 0 || j === styleArray.length - 1 || j === parseInt(styleArray.length / 2)) {
          var _val = styleArray[j].toFixed(1).replace(/\.0+$/, "") || styleArray[j];

          styleArraySimple.push(_val);
        } else {
          styleArraySimple.push(" ");
        }
      }

      this.setState({ stateLabelRangs: styleArraySimple });

      var newViz = _extends({}, this.props.dataJsonConfig.vieweroptions.thematicoptions[index], {
        labelrangs: styleArraySimple
      });

      this.visualizationChanged(index, newViz, false);
    }
  }, {
    key: "updateInfowindowProps",
    value: function updateInfowindowProps(item, val) {
      var newInfowindow = _extends({}, this.props.dataJsonConfig.vieweroptions.infowindow, _defineProperty({}, item, val));

      this.updateViewerOptions("infowindow", newInfowindow);
    }
  }, {
    key: "updateInfowindowPropsAndUpdateMap",
    value: function updateInfowindowPropsAndUpdateMap(item, val) {
      var newInfowindow = _extends({}, this.props.dataJsonConfig.vieweroptions.infowindow, _defineProperty({}, item, val));

      this.updateViewerOptions("infowindow", newInfowindow);

      this.map.current.refreshMap();
    }
  }, {
    key: "updateTimerange",
    value: function updateTimerange(item, value) {
      var newsItem = _extends({}, this.props.dataJsonConfig.timerange, _defineProperty({}, item, value));

      this.props.updateJsonConfig("timerange", newsItem);
    }
  }, {
    key: "updateApps",
    value: function updateApps(item, value) {
      var newsItem = _extends({}, this.props.dataJsonConfig.apps, _defineProperty({}, item, value));

      this.props.updateJsonConfig("apps", newsItem);
    }
  }, {
    key: "updateSelectedfieldsLabels",
    value: function updateSelectedfieldsLabels(fieldName, alias) {
      var newselectedfieldsLabels = _extends({}, this.props.dataJsonConfig.selectedfieldsLabels, _defineProperty({}, fieldName, alias));

      this.props.updateJsonConfig("selectedfieldsLabels", newselectedfieldsLabels);
    }
  }, {
    key: "rendershowPanelModificaRangTemporal",
    value: function rendershowPanelModificaRangTemporal() {
      var _this5 = this;

      if (this.state.showPanelModificaRangTemporal == true && this.props.dataJsonConfig.data.isCSVFile == false) {
        return _react2.default.createElement(_PanelModificaRangTemporal2.default, {
          onClosePanel: function onClosePanel() {
            return _this5.setState({ showPanelModificaRangTemporal: false });
          },
          dataJsonConfig: this.props.dataJsonConfig,
          timerange: this.props.dataJsonConfig.timerange,
          data: this.props.dataJsonConfig.data,
          updateCalendarViewer: this.updateCalendarViewer.bind(this)
        });
      } else {
        return "";
      }
    }
  }, {
    key: "renderMessageGenerateAPP",
    value: function renderMessageGenerateAPP() {
      var _this6 = this;

      if (this.state.showPanelGeneratedApp) {
        return _react2.default.createElement(_PanelMessageGenerateAPP2.default, {
          visor: this.props.dataJsonConfig.apps.visor,
          editor: this.props.dataJsonConfig.apps.editor,
          orga: this.props.dataJsonConfig.organization,
          showMessageGenerateAPP: function showMessageGenerateAPP() {
            return _this6.setState({ showPanelGeneratedApp: false });
          }
        });
      }
    }
  }, {
    key: "renderPanelMessageError",
    value: function renderPanelMessageError() {
      var _this7 = this;

      return _react2.default.createElement(_PanelMessageError2.default, {
        isOpen: this.state.showPanelGeneratedAppError,
        size: "small",
        errorMessage: this.state.errorMessage,
        onClose: function onClose() {
          return _this7.setState({ showPanelGeneratedAppError: false, errorMessage: "" });
        }
      });
    }
  }, {
    key: "renderPanelPropertiesInfoSelector",
    value: function renderPanelPropertiesInfoSelector() {
      if (this.props.dataJsonConfig.vieweroptions.infowindow.viewinfopanel) {
        return _react2.default.createElement(_PanelPropertiesInfoSelector2.default, {
          modeEdicio: true,
          selectedfields: this.props.dataJsonConfig.selectedfields,
          calcdatafields: this.props.dataJsonConfig.calcdatafields,
          selectedfieldsLabels: this.props.dataJsonConfig.selectedfieldsLabels,
          colorPanell: this.props.dataJsonConfig.vieweroptions.infowindow.colorPanell,
          colorPanellText: this.props.dataJsonConfig.vieweroptions.infowindow.colorPanellText,
          updateSelectedfieldsLabels: this.updateSelectedfieldsLabels.bind(this)
        });
      }
    }
  }, {
    key: "renderPanelGetFeatureInfo",
    value: function renderPanelGetFeatureInfo() {
      var _this8 = this;

      return _react2.default.createElement(_PanelGetFeatureInfo2.default, {
        modeEdicio: true,
        viewTitleBar: this.props.dataJsonConfig.vieweroptions.infowindow.viewtitlebar,
        calcdatafieldsCalculs: this.props.dataJsonConfig.calcdatafieldsCalculs,
        calcdatafieldsOptions: this.props.dataJsonConfig.calcdatafieldsOptions,
        selectedfieldsLabels: this.props.dataJsonConfig.selectedfieldsLabels,
        data: this.props.dataJsonConfig.data,
        colorPanell: this.props.dataJsonConfig.vieweroptions.infowindow.colorPanell,
        colorPanellText: this.props.dataJsonConfig.vieweroptions.infowindow.colorPanellText,
        featureInfo: this.state.currentFeature,
        thematics: this.props.dataJsonConfig.vieweroptions.thematicoptions,
        timerange: this.props.dataJsonConfig.timerange,
        showGetFeatureInfo: function showGetFeatureInfo() {
          return _this8.setState({ showGetFeatureInfo: false });
        }
      });
      /* } */
    }
  }, {
    key: "renderPanelsButtonsVisualizations",
    value: function renderPanelsButtonsVisualizations() {
      if (this.props.dataJsonConfig.vieweroptions.layoutoptions.opvisual !== CONSTANTS.DEFAULT_OPVISUAL) {
        return _react2.default.createElement(_PanelButtonsVisualizations2.default, {
          layoutoptions: this.props.dataJsonConfig.vieweroptions.layoutoptions,
          thematicoptions: this.props.dataJsonConfig.vieweroptions.thematicoptions,
          isEditor: true,
          width: this.state.width,
          currentVis: this.state.currentVis
        });
      }
    }
  }, {
    key: "renderPanelLegendVisualization",
    value: function renderPanelLegendVisualization() {
      if (this.props.dataJsonConfig.vieweroptions.infowindow.viewlegend) {
        return _react2.default.createElement(_PanelLegendVisualizations2.default, {
          width: this.state.width,
          layoutOptions: this.props.dataJsonConfig.vieweroptions.layoutoptions,
          thematicoptions: this.props.dataJsonConfig.vieweroptions.thematicoptions,
          stateLabelRangs: this.state.stateLabelRangs
        });
      }
    }
  }, {
    key: "renderSocialButtonsVisualizations",
    value: function renderSocialButtonsVisualizations() {
      if (this.props.dataJsonConfig.vieweroptions.layoutoptions.twitter || this.props.dataJsonConfig.vieweroptions.layoutoptions.facebook) {
        return _react2.default.createElement(_PanelSocialButtons2.default, {
          layoutoptions: this.props.dataJsonConfig.vieweroptions.layoutoptions,
          thematicoptions: this.props.dataJsonConfig.vieweroptions.thematicoptions,
          isEditor: true
        });
      }
    }
  }, {
    key: "renderFilterButtonsVisualizations",
    value: function renderFilterButtonsVisualizations() {
      if (this.props.dataJsonConfig.vieweroptions.infowindow.viewfilter) {
        return _react2.default.createElement(_PanelFilterButtons2.default, {
          infowindow: this.props.dataJsonConfig.vieweroptions.infowindow,
          thematicoptions: this.props.dataJsonConfig.vieweroptions.thematicoptions,
          dataJsonConfig: this.props.dataJsonConfig,
          stationsFonts: this.state.stationsFonts,
          updateInfowindowPropsAndUpdateMap: this.updateInfowindowPropsAndUpdateMap.bind(this),
          isEditor: true
        });
      }
    }
  }, {
    key: "renderCercadorButtonsVisualizations",
    value: function renderCercadorButtonsVisualizations() {
      if (this.props.dataJsonConfig.vieweroptions.infowindow.viewcercador) {
        return _react2.default.createElement(_PanelCercadorMap2.default, {
          infowindow: this.props.dataJsonConfig.vieweroptions.infowindow,
          zoomToMap: this.zoomToMap.bind(this),
          isEditor: true
        });
      }
    }
  }, {
    key: "renderMap",
    value: function renderMap() {
      var _this9 = this;

      // console.log('mana', this.manageGeojsonData)
      if (this.state.loadingMap) {
        return _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { active: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { size: "massive" },
            "Carregant mapa"
          )
        );
      }

      return _react2.default.createElement(_Map2.default, {
        ref: this.map,
        vieweroptions: this.props.dataJsonConfig.vieweroptions,
        datafields: this.props.dataJsonConfig.calcdatafields,
        calcdatafields: this.props.dataJsonConfig.calcdatafields,
        calcdatafieldsCalculs: this.props.dataJsonConfig.calcdatafieldsCalculs,
        calcdatafieldsOptions: this.props.dataJsonConfig.calcdatafieldsOptions,
        panelindex: this.state.activeIndex,
        getFeatureInfo: this.getFeatureInfo.bind(this),
        updateLayerStyle: this.updateLayerStyle.bind(this),
        getTimeStamps: function getTimeStamps(timestamps) {
          return _this9.updateTimerange("timestamps", timestamps);
        },
        getTimeStampsCalcValue: function getTimeStampsCalcValue(timestampscalcvalue) {
          return _this9.updateTimerange("timestampscalcvalue", timestampscalcvalue);
        },
        timerange: this.props.dataJsonConfig.timerange,
        manageGeojsonError: this.manageGeojsonError,
        manageGeojsonData: this.manageGeojsonData.bind(this)
      });
    }
  }, {
    key: "renderButonsCanvi",
    value: function renderButonsCanvi() {
      var _this10 = this;

      //console.info("this.props.isNewVisor", this.props.isNewVisor);
      if (!this.props.isNewVisor && !this.props.dataJsonConfig.data.isCSVFile) {
        return _react2.default.createElement(_semanticUiReact.Popup, {
          content: "Canviar dates consulta",
          trigger: _react2.default.createElement(_semanticUiReact.Icon, {
            onClick: function onClick(e, data) {
              return _this10.onshowPanelModificaRangTemporal(data);
            },
            className: _PanelVisualitzarDades2.default.iconPos,
            color: "black",
            size: "large",
            name: "calendar outline"
          })
        });
      } else {
        return " ";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: _PanelVisualitzarDades2.default.containerMap },
        _react2.default.createElement(
          "div",
          { className: _PanelVisualitzarDades2.default.toolbarOptions, id: "tools" },
          _react2.default.createElement(_semanticUiReact.Accordion, {
            defaultActiveIndex: [0],
            panels: this.getPanels(),
            exclusive: false,
            fluid: true,
            styled: true
          }),
          _react2.default.createElement(
            "div",
            { className: _PanelVisualitzarDades2.default.buttonMain },
            this.renderButonsCanvi(),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                loading: this.state.generatingApp,
                color: "teal",
                onClick: this.doGenerateApp
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: "map outline" }),
              "Generar VISOR"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { id: "map" },
          this.state.currentFeature.properties && this.state.showGetFeatureInfo && this.renderPanelGetFeatureInfo(),
          this.renderPanelsButtonsVisualizations(),
          this.renderSocialButtonsVisualizations(),
          this.renderFilterButtonsVisualizations(),
          this.renderCercadorButtonsVisualizations(),
          this.renderPanelLegendVisualization(),
          this.rendershowPanelModificaRangTemporal(),
          this.renderMessageGenerateAPP(),
          this.renderPanelMessageError(),
          this.renderMap()
        )
      );
    }
  }]);

  return PanelVisualitzarDades;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this11 = this;

  this.handleWindowSizeChange = function () {
    _this11.setState({ width: window.innerWidth }, function () {
      return console.log(_this11.state.width);
    });
  };

  this.handleClick = function (e, titleProps) {
    var index = titleProps.index;
    var activeIndex = _this11.state.activeIndex;

    var newIndex = activeIndex === index ? -1 : index;

    _this11.setState({ activeIndex: newIndex });
  };

  this.updateMapview = function (e, _ref3) {
    var value = _ref3.value;

    _this11.updateViewerOptions("initview", value);
  };

  this.getFeatureInfo = function (feature) {
    return _this11.setState({ currentFeature: feature, showGetFeatureInfo: true });
  };

  this.updateLayoutOptions = function (item, value) {
    var newLayoutOptions = _extends({}, _this11.props.dataJsonConfig.vieweroptions.layoutoptions, _defineProperty({}, item, value));

    _this11.updateViewerOptions("layoutoptions", newLayoutOptions);
  };

  this.doGenerateApp = function () {
    if (_this11.props.dataJsonConfig.vieweroptions.layoutoptions.title === CONSTANTS.DEFAULT_TITOL_GENERIC) {
      _this11.setState({
        showPanelGeneratedAppError: true,
        generatingApp: false,
        errorMessage: "Cal canviar el títol del visor a 'Propietats visor > Títol visor' "
      });
    } else {
      //this.updateViewerOptions("isNewVisor", false);

      _this11.setState({ generatingApp: true });

      var currentView = _this11.map.current.getCurrentView();
      _this11.updateViewerOptions("initview", currentView);

      var newJsonConfig = _extends({}, _this11.props.dataJsonConfig, {
        vieweroptions: _extends({}, _this11.props.dataJsonConfig.vieweroptions, {
          initview: currentView,
          isNewVisor: false
        })
      });

      setTimeout(function () {
        var _this12 = this;

        _request2.default.put(CONSTANTS.URL_GENERATE_GEOJSON + "/" + this.props.dataJsonConfig.apps.editor, this.props.dataJsonConfig).then(function () {
          //this.updateViewerOptions("isNewVisor", false);
          //this.updateViewerOptions("initview", currentView);
          _this12.setState({
            showPanelGeneratedApp: true,
            generatingApp: false
          });
          _this12.getBBOXOptions();
        }).catch(function (err) {
          console.log(err);
          _this12.setState({
            showPanelGeneratedAppError: true,
            generatingApp: false,
            errorMessage: "Problema en generar el visor. Torni a intentar-ho."
          });
        });
      }.bind(_this11), 100);
    }

    //this.getTAGSOptions();
  };

  this.manageGeojsonError = function () {
    _this11.setState({ loadingMap: true });
    _this11.manageMapData("");
  };

  this.onSaveAsNewMap = function (checked) {
    _this11.setState({ saveAsNewMap: checked });
  };

  this.onshowPanelModificaRangTemporal = function () {
    if (_this11.state.showPanelModificaRangTemporal == false) {
      _this11.setState({ showPanelModificaRangTemporal: true });
    } else {
      _this11.setState({ showPanelModificaRangTemporal: false });
    }
  };

  this.manageGeojsonData = function (mapaData) {

    try {
      var stationsFonts = _utils2.default.createSetfromGeoJSON(mapaData.features, "font");

      _this11.setState({ stationsFonts: stationsFonts });
      _this11.props.updateJsonConfig("selectedorganizations", stationsFonts);
    } catch (err) {
      console.info("manageGeojsonError", err);
    }
  };

  this.isValid = function () {
    return true;
  };
};

exports.default = PanelVisualitzarDades;


PanelVisualitzarDades.propTypes = {
  dataJsonConfig: _propTypes2.default.object,
  myStep: _propTypes2.default.number,
  updateJsonConfig: _propTypes2.default.func,
  isNewVisor: _propTypes2.default.bool,
  organization: _propTypes2.default.string
};
